import styled from 'styled-components';
import tw, { classnames, padding, position, display, gap, gridTemplateColumns, flexDirection } from 'tailwindcss-classnames'

// export const Container = styled.div.attrs({
//     className: classnames(padding('py-0'), position('relative'))
// })``;

const ContentClassBase = classnames(position('relative'));
export const GridContent = () => styled.div.attrs({
    className: classnames(ContentClassBase, display('grid'), gap('gap-4'), gridTemplateColumns('grid-cols-1', 'md:grid-cols-1', 'lg:grid-cols-2'))
})``;

export const FlexContent = () => styled.div.attrs({
    className: classnames(ContentClassBase, display('flex'), flexDirection('flex-col'))
})``;